// extracted by mini-css-extract-plugin
module.exports = {"MainNav":"style_MainNav__3DY7M","yellow":"style_yellow__3wPiN"};